module.exports = __webpack_public_path__ + "img/USERS_SETTING.de2a008e.svg";